<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.form index") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row"></div>
    <div class="row">

      <div
        v-if="roleprivileges.includes('Submit Form Patient Schedule')"
        class="col-lg-12 mb-1"
      >
        <div class="ibox-body">
          <div class="ibox-content horizondalscroll contentminheight">
            <ul class="tree pl-1">
  <li>
    <!-- put study list here -->
    <input type="checkbox" id="studyliststudyId" @change="listtemplate(studylist.studyId)" />
    <label class="tree_label" for="studyliststudyId">{{ studylist.studyRef }}</label>
    <ul>
      <li v-for="(templates) in templatelistobj[studylist.studyId]" :key="templates.templateId">
        <!-- put forms here instead of sites -->
        <input
          type="checkbox"
          :id="templates.templateId"
           @change="getlanguages(templates.sourceTemplateId, templates.templateName)"
        />
        <label class="tree_label" :for="templates.templateId">{{ templates.templateName }}</label>
        <ul>
      <li v-for="(languages) in formsbylanguage[templates.sourceTemplateId]" :key="languages.Language">
        <!-- put forms here instead of sites -->
        <input
          type="checkbox"
          :id="languages.Language+templates.templateId"
        />
        <label class="tree_label" :for="languages.Language+templates.templateId">{{ languages.Language }}</label>
            <ul>
                  <li v-for="langdata in languages.Data" :key="langdata.id">
                      <input
                        type="checkbox"
                        :id="langdata.id"
                        @click.stop.prevent="gotofrom(langdata.id)"
                      />
                      <label
                        class="tree_form_label"
                        @click.stop.prevent="gotofrom(langdata.id)"
                      >
                        {{ langdata.version }}
                      </label>
                    </li>
                </ul>
      </li>
    </ul>
      </li>
    </ul>
  </li>
</ul>
          </div>
        </div>
      </div>
    </div>
  </div>
<showformmodel
    v-if="showform"
    :formid="currentform"
    :currentformstatus="currentformstatus"
    @closeformModal="closeformModal()"
  />
</template>
<script src="./form_index.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "./tree.css";

/* Tooltip box */
.custom-tooltip-text,
.custom-form-tooltip-text {
   position: absolute;
    inset: auto;
    margin: 0;
    bottom: anchor(top);
    right: anchor(right);
    background-color: #616161;
    color: white;
    padding: 6px 10px;
    font-size: 0.75rem;
    border-radius: 4px;
    border: none;
    max-width: 180px;
    white-space: normal;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    margin-block-end: 4px;

}
.custom-tooltip-text:popover-open{
  display: grid;
}

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu > button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.visit-popup-menu > .popup-menu-block:hover,
.popup-submenu > div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}
.modal-wrapper-changetemplate {
position: fixed;
left: 0;
top: 0;
background: rgba(0, 0, 0, 0.5);
height: 100%;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
opacity: 1;
pointer-events: auto;
overflow: hidden;
z-index: 9999;
}
.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 80vh;
}
.contentminheight {
    min-height: 460px;
}
</style>
